import React, { useState } from "react";
import ProjectSection from "./ProjectSection";
import ProjectSectionMap from "./ProjectSectionMap";
import ProjectSectionField from "./ProjectSectionField";



const AccessSection = () => {
  const [activeComponent, setActiveComponent] = useState("Section");
  // Array with tab names and corresponding components
  const tabs = [
    { name: "Section", component: <ProjectSection /> },
    { name: "Section Map", component: <ProjectSectionMap /> },
    { name: "Section Field", component: <ProjectSectionField /> },
  ];

  // Find the active tab and its component
  const renderComponent = () => {
    const activeTab = tabs.find(tab => tab.name === activeComponent);
    return activeTab ? activeTab.component : null;
  };

  const changeActiveComponent = (name) => {
    setActiveComponent(name)
  }

  return (
    <div className="min-h-screen flex flex-col items-center p-0 pt-0">
        <div className="flex space-x-2 mb-1 max-w-100 flex-wrap gap-2">
          {tabs.map(({ name }) => (
            <button
              key={name}
              className={`px-3 py-2 rounded-lg text-sm border-b-2 ${activeComponent === name
                  ? "activeBtn text-white"
                  : "bg-neutral-50 text-gray-800 hover:bg-blue-100"
                }`}
              onClick={() => { changeActiveComponent(name) }}
            >
              {name}
            </button>
          ))}
        </div>

      {renderComponent()}
    </div>
  );
};

export default AccessSection;
